// INSTANCES
import { SettingsInfo, SettingsInfoDto } from '@/types/SettingsInfo';
import { ApiAxiosInstance } from '../instances/apiAxiosInstance';



export const settingsInfoClient = {
  getSettingsInfo () {
    return ApiAxiosInstance.get<SettingsInfo[]>('wallet-b2b/settings-info')
  },
  postSettingInfo (payload: SettingsInfoDto) {
    return ApiAxiosInstance.post<SettingsInfo>(`wallet-b2b/b2b/settings`, payload);
  },
  putSettingInfo (payload: SettingsInfo) {
    return ApiAxiosInstance.put<SettingsInfo>(`wallet-b2b/settings-info`, payload)
  },
  deleteSettingsInfo (settingId: number) {
    return ApiAxiosInstance.delete<SettingsInfo>('wallet-b2b/settings-info', {
      params: {
        settingId,
      }
    })
  },

};
